import React from 'react';
import { TextInput } from '../../../../UI';
import styles from './AdminChatForm.module.scss';

interface TraceTagInputProps {
  traceTag: string;
  onChange: (value: string) => void;
}

const TraceTagInput: React.FC<TraceTagInputProps> = ({ traceTag, onChange }) => {
  return (
    <div className={styles.inputGroup}>
      <TextInput
        label="Trace Tag"
        value={traceTag}
        onChange={onChange}
        placeholder="Optional trace tag"
      />
    </div>
  );
};

export default TraceTagInput;
